// material-ui
import { styled, ThemeProvider, useTheme } from '@mui/material/styles';
import { Avatar, Box, Divider, Grid, IconButton, List, ListItem, ListItemAvatar, ListItemButton, ListItemText, Paper, Typography } from '@mui/material';

// project imports

// assets
import { LuAppWindow } from "react-icons/lu";

// types
import PropTypes from 'prop-types';
import MainCard from '../ui-component/cards/MainCard';
import TotalIncomeCard from './TotalIncomeCard';
import { useSelector } from 'react-redux';
import customtheme from '../themes';
import { ContextUserInfo } from '../Layout/MainLayout/index';
import { ContextNotification, severitys } from '../App';
import { useContext, useEffect, useState } from 'react';
import UserApi from '../api/UserApi';
import axios from 'axios';
import RtlProvider from './RtlProvider';




// ==============================|| DASHBOARD - TOTAL INCOME DARK CARD ||============================== //

const DarkCard = ({ dark, icon, isLoading, title, descrypion, domain, RoleName }) => {

  const { setOpen } = useContext(ContextNotification);
  const theme = useTheme();
  const customization = useSelector((state) => state.customization);
  const { userInfo } = useContext(ContextUserInfo);
  const [ip, setIP] = useState("");

  useEffect(() => {
    //passing getData method to the lifecycle method
    getip();
  }, []);

  const getip = async () => {
    try{
const res = await axios.get("https://api.ipify.org/?format=json");
    setIP(res.data.ip);
    }
    catch(err)
    {
      console.log(err);
      setIP('');
    }
    
  };

  const generateSharedKey = () => {
    var res = '';

    ip.split('.').map((p) => {
      if (p.length === 3) res = res + p;
      else if (p.length === 2) res = res + '0' + p;
      else res = res + '00' + p;
    });

    return res;

  }
  const GoToApp = () => {
    var skey = generateSharedKey();

    UserApi.Encrypt(userInfo.username, skey)
      .then((data) => {
        const encrypted = data.data;
        if (encrypted) {
          var pathurl = `${domain}/CheckAuth/${encrypted}`;
          if (RoleName.trim()!=='')
            pathurl = `${pathurl}/${RoleName}`
          OpeninnewTab(pathurl);
        }
        else
          OpeninnewTab(`${domain}`);
      })
      .catch(err => {
        if(err.status && err.status===401){
          window.location.pathname = "/login";
      }
        if (err.response && err.response.data) {
          setOpen({ IsEnable: true, Message: JSON.stringify(err.response.data), severity: severitys.error });
        }
        else if (err.response && err.response.data && err.response.data.errors) {
          setOpen({ IsEnable: true, Message: JSON.stringify(err.response.data.errors), severity: severitys.error });
        }
        else if (err.message) {
          setOpen({ IsEnable: true, Message: JSON.stringify(err.message), severity: severitys.error });
        }
        OpeninnewTab(`${domain}`);
      }
      )


  }

  function OpeninnewTab(path) {
    window.open(`${path}`);
  }




  return (

    <>
      <RtlProvider>
        <ThemeProvider theme={customtheme(customization)}>

          {isLoading ? (
            <TotalIncomeCard />
          ) : (

            <MainCard
              border={false}
              content={false}
              sx={{
                cursor: 'pointer',
                bgcolor: 'secondary.dark',
                boxShadow: 3,

                overflow: 'hidden',
                position: 'relative',
                '&:after': {
                  content: '""',
                  position: 'absolute',
                  width: 210,
                  height: 210,
                  background: theme.palette.secondary[800],
                  borderRadius: '50%',
                  top: { xs: -105, sm: -85 },
                  right: { xs: -140, sm: -95 }
                },
                '&:before': {
                  cursor: 'pointer',
                  content: '""',
                  position: 'absolute',
                  width: 210,
                  height: 210,
                  background: theme.palette.secondary[800],
                  borderRadius: '50%',
                  top: { xs: -155, sm: -125 },
                  right: { xs: -70, sm: -15 },
                  opacity: 0.5
                }
              }}
              style={{ background: dark ? 'linear-gradient(to right top, #000066, #ffffff)' : 'linear-gradient(to right top, #ccccff, #ffffff)' }}

              darktitle={true}
              children={<Box sx={{
                width: 210,
                height: 150
              }}>
                <Box sx={{ px: 2 }}>
                  <IconButton color="inherit" size="large">{icon}</IconButton>
                  <Typography component="h1" variant="h5" style={{ fontSize: 15 }} sx={{ color: theme.palette.primary[800] }}>
                    {title}
                  </Typography>
                </Box>
              </Box>


              }
              onClick={() => { GoToApp() }}
            >



            </MainCard>



          )}

        </ThemeProvider>
      </RtlProvider>
    </>
  );
};

DarkCard.propTypes = {
  isLoading: PropTypes.bool
};

export default DarkCard;
